import { render, staticRenderFns } from "./18.vue?vue&type=template&id=7888b650&scoped=true&"
var script = {}
import style0 from "./18.vue?vue&type=style&index=0&id=7888b650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7888b650",
  null
  
)

export default component.exports